import appmixer from '../../plugins/appmixer';

export default class InsightsRequests {
    getInsights(from, to) {
        return appmixer.api.request({
            url: `${appmixer.api.get('baseUrl')}/telemetry/messages?from=${from}&to=${to}`,
            method: 'GET'
        });
    }
};
